export default __webpack_public_path__ + "static/media/Rockwool-Sandwich-Panel.d3815f71.jpg";